import { Trade, ETHER, Token, ChainId } from '@uniswap/sdk'
import React, { Fragment, memo, useContext } from 'react'
import { ChevronRight } from 'react-feather'
import { Flex } from 'rebass'
import { ThemeContext } from 'styled-components'
import { TYPE } from '../../theme'
import CurrencyLogo from '../CurrencyLogo'
import { useSelectedTokenList } from '../../state/lists/hooks'
import { useActiveWeb3React } from '../../hooks'

export default memo(function SwapRoute({ trade }: { trade: Trade }) {
  const theme = useContext(ThemeContext)
  const tokenList = useSelectedTokenList()
  const { chainId } = useActiveWeb3React()

  // 根据链ID获取原生代币符号
  const getNativeCurrencySymbol = () => {
    if (chainId === ChainId.BSC) {
      return 'BNB'
    }
    return 'K'
  }

  // 创建显示路径，将包装代币替换为用户选择的原始代币
  const displayPath = trade.route.path.map((token, i, path) => {
    const isLastItem = i === path.length - 1

    // 如果是最后一个代币且用户选择的是原生代币，显示原生代币
    if (isLastItem && trade.originalOutputCurrency === ETHER) {
      return ETHER
    }

    // 其他情况显示原始代币
    return token
  })

  return (
    <Flex
      px="0.5rem"
      py="0.5rem"
      my="0.5rem"
      style={{ border: `1px solid ${theme.bg3}`, borderRadius: '1rem' }}
      flexWrap="wrap"
      width="100%"
      justifyContent="space-evenly"
      alignItems="center"
    >
      {displayPath.map((token, i, path) => {
        const isLastItem: boolean = i === path.length - 1

        // 对于原生代币，直接使用 ETHER
        if (token === ETHER) {
          return (
            <Fragment key={i}>
              <Flex my="0.5rem" alignItems="center" style={{ flexShrink: 0 }}>
                <CurrencyLogo currency={ETHER} size="1.5rem" />
                <TYPE.black fontSize={14} color={theme.text1} ml="0.5rem">
                  {getNativeCurrencySymbol()}
                </TYPE.black>
              </Flex>
              {isLastItem ? null : <ChevronRight color={theme.text2} />}
            </Fragment>
          )
        }

        // 对于其他代币，尝试从 token list 中获取带有图标信息的代币
        const tokenWithLogo = token instanceof Token ? tokenList[token.chainId]?.[token.address] : undefined
        const displayToken = tokenWithLogo || token

        return (
          <Fragment key={i}>
            <Flex my="0.5rem" alignItems="center" style={{ flexShrink: 0 }}>
              <CurrencyLogo currency={displayToken} size="1.5rem" />
              <TYPE.black fontSize={14} color={theme.text1} ml="0.5rem">
                {displayToken.symbol}
              </TYPE.black>
            </Flex>
            {isLastItem ? null : <ChevronRight color={theme.text2} />}
          </Fragment>
        )
      })}
    </Flex>
  )
})
